// extracted by mini-css-extract-plugin
module.exports = {"button":"ModerateCardDetailsContainer-button-d246dff9dcef8f297e5285fc7c213015"};